export const REGISTRATION_HEADERS = [
    { text: "Registration ID", value: "regid", width: "18rem" },
    { text: "FQDN", value: "fqdn", width: "18rem" },
    { text: "Protocol", value: "regtype", width: "10rem" },
    { text: "Officer", value: "officer", width: "12rem" },
    { text: "Creation date", value: "creationdate", width: "16rem" },
    { text: "Status", value: "status", width: "7rem" },
    { text: "Validity", value: "validity", width: "7rem" },
    { value: "actions", sortable: false, width: "2rem", required: true, draggable: false },
].map((header) => {
    return {
        sortable: true,
        divider: true,
        text: "",
        required: false,
        draggable: true,
        defaultVisible: true,
        ...header
    };
});
